class ProductAr3d extends HTMLElement {
  constructor () {
    super()

    this.itemExternalEl = window.BAO.utils.getElement(
      '[data-external-el="product-ar3d.item"]'
    )
    this.triggerEl = window.BAO.utils.getElement(
      '[data-el="product-ar3d.trigger"]'
    )
    this.labelEl = window.BAO.utils.getElement('[data-el="product-ar3d.label"]')

    this.triggerEl.addEventListener('click', this.onButtonClick.bind(this))
  }

  onButtonClick () {
    this.labelEl.innerText =
      this.labelEl.innerText.toLowerCase() ===
      this.labelEl.dataset.closeLabel.toLowerCase()
        ? this.labelEl.dataset.openLabel
        : this.labelEl.dataset.closeLabel

    this.itemExternalEl.setAttribute(
      'aria-hidden',
      this.itemExternalEl.getAttribute('aria-hidden') === 'true'
        ? 'false'
        : 'true'
    )
  }
}

customElements.define('product-ar3d', ProductAr3d)
